export enum PanelWidthVariation {
  Skinny = "skinny",
  SemiSkinny = "semiskinny",
  Normal = "normal",
}

export const getPanelWidthVariation = (width: number): PanelWidthVariation => {
  // less than 285px is considered skinny.
  const skinnyVarationCutoff = 285;
  const semiSkinnyVariationCutoff = 325;
  if (width < skinnyVarationCutoff) {
    return PanelWidthVariation.Skinny;
  }
  if (width < semiSkinnyVariationCutoff) {
    return PanelWidthVariation.SemiSkinny;
  }
  return PanelWidthVariation.Normal;
};
